import { goToLogin } from '@/utils/auth';
import axios from '../axios'

import { IAutoLoginParams, ILoginData, ILoginParams } from './login.types';

import { baseUrl } from '@/utils/global'

export function buildCaptchaUrl(flag: string) {
    return baseUrl + '/captcha?flag=' + flag
}
export function login(params: ILoginParams) {
    return axios<ILoginData>({
        url: 'login',
        method: 'post',
        data: params,
        notRequireLogin: true,
    })
}

export function logout(vm: Vue) {
    return axios({
        method: 'get',
        url: 'logout'
    }).finally(() => {
        goToLogin(vm.$router)
    })
}

export function autoLogin(param: IAutoLoginParams) {
    return axios<ILoginData>({
        url: 'autoLogin',
        method: 'post',
        data: param,
        notRequireLogin: true,
    })
}